import { render, staticRenderFns } from "./SubHeaderSection.vue?vue&type=template&id=0541b68d&scoped=true"
import script from "./SubHeaderSection.vue?vue&type=script&lang=ts"
export * from "./SubHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./SubHeaderSection.vue?vue&type=style&index=0&id=0541b68d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541b68d",
  null
  
)

export default component.exports